export interface customFormField {
  type: string;
  dataType: string;
  label: string;
  id?: number,
  required: boolean;
  dropdown_options: any[] | [];
}

export const CLIENT_MODULE_ENUM = {
  companies: "COMPANIES",
  contact: "CONTACT",
  ticket: "TICKET_CREATION",
  survey: "CUSTOM_SURVEY"
};

export interface customFormFieldPayload {
  id: number;
  list: Array<customFormField>;
}

export interface customFormFieldPayloadResponse {
  error: string;
  statusCode: number;
  payload: Array<customFormField> | null | [];
}

export const CONTACT_MODULE = "CONTACT";
export const COMPANY_MODULE = "COMPANY";
export const TICKET_MODULE = "TICKET_CREATION"
export const SURVEY_MODULE = "CUSTOM_SURVEY"

export const CUSTOM_FIELDS_TYPES_ENUM = {
  textarea: "TEXTAREA",
  datePicker: "DATEPICKER",
  dropdown: "DROPDOWN",
};

export const SAMPLE_CUSTOM_FORM_FIELDS = [
  {
    id: 8,
    orgID: "16400",
    module: "CONTACT",
    dataJSON: null,
    data: {
      list: [
        {
          type: "TEXTAREA",
          dataType: "TEXT",
          label: "AREA_NAME",
          required: true,
          dropdown_options: [],
        },
        {
          type: "INPUT",
          dataType: "TEXT",
          label: "METER_NUMBER",
          required: true,
          dropdown_options: [],
        },
        {
          type: "DROPDOWN",
          dataType: "TEXT",
          label: "METER_TYPE",
          required: true,
          dropdown_options: ["option A", "Option B"],
        },
      ],
    },
    isDeleted: false,
  },
  {
    id: 8,
    orgID: "16400",
    module: "COMPANY",
    dataJSON: null,
    data: {
      list: [
        {
          type: "TEXTAREA",
          dataType: "TEXT",
          label: "AREA_NAME",
          required: true,
          dropdown_options: [],
        },
        {
          type: "INPUT",
          dataType: "text",
          label: "METER_NUMBER",
          required: true,
          dropdown_options: [],
        },
        {
          type: "DROPDOWN",
          dataType: "TEXT",
          label: "METER_TYPE",
          required: true,
          dropdown_options: ["option A", "Option B"],
        },
      ],
    },
    isDeleted: false,
  },
  {
    id: 8,
    orgID: "16400",
    module: "TICKET_CREATION",
    dataJSON: null,
    data: {
      list: [
        {
          type: "TEXTAREA",
          dataType: "TEXT",
          label: "AREA_NAME",
          required: true,
          dropdown_options: [],
        },
        {
          type: "INPUT",
          dataType: "text",
          label: "METER_NUMBER",
          required: true,
          dropdown_options: [],
        },
        {
          type: "DROPDOWN",
          dataType: "TEXT",
          label: "METER_TYPE",
          required: true,
          dropdown_options: ["option A", "Option B"],
        },
      ],
    },
    isDeleted: false,
  },
  {
    id: 8,
    orgID: "16400",
    module: "CUSTOM_SURVEY",
    dataJSON: null,
    data: {
      list: [
        {
          type: "TEXTAREA",
          dataType: "TEXT",
          label: "Where do you live?",
          dropdown_options: [],
        },
        {
          type: "INPUT",
          dataType: "text",
          label: "What's your name?",
          dropdown_options: [],
        },
        {
          type: "DROPDOWN",
          dataType: "TEXT",
          label: "How Severe is the issue?",
          dropdown_options: ["option A", "Option B"],
        },
      ],
    },
    isDeleted: false,
  },
];

export const DROPDOWN_CONFIG = {
  search: true, // true/false for the search functionlity defaults to false,
  placeholder: "Select Option", // text to be displayed when no item is selected defaults to Select,
  limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
  noResultsFound: "No results found!", // text to be displayed when no items are found while searching
  searchPlaceholder: "search",
};
